import React, {forwardRef, useImperativeHandle} from 'react';
import {useMeHeader} from './hooks';
import MeTopUser from './top-user';
import MeUserInfo from './info';
import VipHalfCard from '@/common-pages/vip/vip-half-card';
import MeWallet from './me-wallet';
import MePromotions from './me-promotions';

const MeHeaderV2 = forwardRef(({}, ref) => {
  const {login, vipCardRef, refresh} = useMeHeader();

  useImperativeHandle(
    ref,
    () => ({
      refresh: (isClick?: boolean) => refresh(isClick),
    }),
    [refresh],
  );

  return (
    <>
      <MeTopUser />
      <div className="relative flex flex-col gap-2 px-3 pt-4 pb-2">
        <div
          className="absolute left-0 top-0 z-[0] h-[26.875rem] w-full rounded-none bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${require('@/assets/imgs/me/me-bg.webp')})`,
          }}
        />
        <MeUserInfo />
        <div className="flex flex-col">
          <div className="-mb-3">
            <VipHalfCard login={login} ref={vipCardRef} />
          </div>
          <MeWallet />
        </div>
        <MePromotions />
      </div>
    </>
  );
});

export default MeHeaderV2;
